import { render, staticRenderFns } from "./EditSensitiveWordDialog.vue?vue&type=template&id=fa1da876"
import script from "./EditSensitiveWordDialog.vue?vue&type=script&lang=js"
export * from "./EditSensitiveWordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports